import { ESdChangeReason } from "@kuika/kuika-cl-model";
import React from "react";
import isEqual from "react-fast-compare";
import { IWithSDProps } from "./hoc/screen-design-consumer";

export interface IPureDesignComponentState {}

export interface IPureDesignComponentProps {}

export abstract class PureSdComponent<Props, State> extends React.Component<
  IPureDesignComponentProps & IWithSDProps & Props,
  IPureDesignComponentState & State
> {
  constructor(props) {
    super(props);
  }

  abstract checkNeedRender: (
    changeReason: ESdChangeReason,
    nextProps: IPureDesignComponentProps & IWithSDProps & Props,
    nextState: IPureDesignComponentState
  ) => boolean;

  shouldComponentUpdate(
    nextProps: IPureDesignComponentProps & IWithSDProps & Props,
    nextState: IPureDesignComponentState
  ) {
    // eslint-disable-next-line @typescript-eslint/dot-notation
    const comparizationState = isEqual(nextState, this.state);
    if (comparizationState === false) {
      // console.info(concat("WithSd", "class:", this.constructor.name, "render:", "true", "reason:", "internalStateChanged").join(" -> "));
      return true;
    }
    const comparizationProps = isEqual(nextProps, this.props);
    if (comparizationProps === false) {
      if (
        nextProps.sd?.changeReason === ESdChangeReason.LoadProject ||
        nextProps.sd?.changeReason === ESdChangeReason.OtherSetStates ||
        nextProps.sd?.changeReason === ESdChangeReason.Undo ||
        nextProps.sd?.changeReason === ESdChangeReason.Redo ||
        nextProps.sd?.changeReason === ESdChangeReason.Terminate ||
        nextProps.sd?.changeReason === ESdChangeReason.ScreenReload
      ) {
        // this.log(true, nextProps.sd?.changeReason, nextProps.sd?.changeReasonParameter);
        return true;
      }
      if (
        nextProps.sd?.changeReason !== undefined &&
        (nextProps.sd?.changeReason !== this.props.sd.changeReason ||
          nextProps.sd?.changeReasonParameter !== this.props.sd.changeReasonParameter ||
          (nextProps.sd?.changeReason === this.props.sd.changeReason &&
            nextProps.sd?.changeReasonParameter === undefined &&
            this.props.sd.changeReasonParameter === undefined))
      ) {
        const checkNeedRender: boolean = this.checkNeedRender(nextProps.sd?.changeReason, nextProps, nextState);
        // this.log(checkNeedRender, nextProps.sd?.changeReason, nextProps.sd?.changeReasonParameter);
        return checkNeedRender;
      }
      // console.info(concat("WithSd", "class:", this.constructor.name, "render:", "true", "reason:", "propsChangedNotBySd").join(" -> "));
      return true;
    }
    // console.info(concat("WithSd", "class:", this.constructor.name, "render:", "false", "reason:", "notChangeAnyStateOrProps").join(" -> "));
    return false;
  }

  log = (result: boolean, changeReason?: ESdChangeReason, changeReasonParameter?: string) => {
    let currentChangeReason = "";
    if (changeReason) {
      currentChangeReason = ESdChangeReason[changeReason].toString();
    }
    // console.info(concat("WithSd", "class:", this.constructor.name, "render:", result ? "true" : "false", "reason:", currentChangeReason, "parameter:", changeReasonParameter).join(" -> "));
  };
}
